import { fetchBreeds } from 'nove8/helpers/api/fetchBreeds'
import { fetchCommands } from 'nove8/helpers/api/fetchCommands'
import { useEffect, useMemo } from 'react'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'

export const useGetBreedsAndCommands = (): void => {
  const language = useZustandSessionStore((state) => state.language)

  const requestLanguage = useMemo(() => {
    if (language === 'jp') return 'ja'
    if (language === 'kr') return 'ko'
    return language
  }, [language])

  useEffect(() => {
    if (!requestLanguage) return

    fetchBreeds(requestLanguage)
    fetchCommands(requestLanguage)
  }, [requestLanguage])
}
